import AnimateInView from '@atoms/AnimateInView/AnimateInView';
import SiteEnum from '@models/enums/SiteEnum';
import ThemeEnum from '@models/enums/ThemeEnum';
import { IColourSwatchCard } from '@models/IColourSwatchCard';
import { IMeta } from '@models/IMeta';
import ColourSwatchCard from '@molecules/ColourSwatchCard/ColourSwatchCard';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import { fadeInUp } from '@utility/config/animations';
import { motion } from 'motion/react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly cards: IColourSwatchCard[];
  readonly header?: string;
  readonly meta?: IMeta;
  readonly theme?: ThemeEnum;
  readonly variant?: 'fullScreen' | 'narrow';
}

const ColourCardCarousel = ({
  cards,
  header,
  meta,
  theme = ThemeEnum.Light,
  variant = 'fullScreen',
}: Props) => {
  const isFullScreen = variant === 'fullScreen';

  return (
    <AnimateInView>
      <NavigationCarousel
        title={header}
        numberOfSlides={cards.length}
        id={meta?.contentLink ? `colour-${meta?.contentLink}` : ''}
        slidesToShowMobile={2}
        slidesToShowTabletPortrait={isFullScreen ? 3 : 2}
        slidesToShowTabletLandscape={isFullScreen ? 3 : 2}
        slidesToShowDesktop={isFullScreen ? 5 : 3}
        slidesToShowLargeDesktop={isFullScreen ? 5 : 3}
        overflow={false}
        breakpoints={{
          0: {
            spaceBetween: 16,
          },
          1024: {
            spaceBetween: 32,
          },
        }}
        site={SiteEnum.Deco}
        theme={theme}
      >
        {cards.map((card: IColourSwatchCard) => (
          <SwiperSlide
            key={card.meta?.contentLink || card.colourCode}
            className="stretch-card tw-h-full"
          >
            <motion.div variants={fadeInUp} className="tw-dark tw-h-full">
              <ColourSwatchCard {...card} />
            </motion.div>
          </SwiperSlide>
        ))}
      </NavigationCarousel>
    </AnimateInView>
  );
};
export default ColourCardCarousel;
